import $ from 'jquery'
import 'jquery-datetimepicker'

$(() => {
  // Get the modal
  const modal = document.getElementById('bookAppointmentModal')

  // Get the button that opens the modal
  const btn = document.querySelectorAll('[data-appointment-trigger]').forEach(btn => {
    // When the user clicks the button, open the modal
    btn.onclick = function () {
      modal.style.display = 'flex'
    }
  })

  // Get the <span> element that closes the modal
  const modalClose = document.getElementById('modalClose')

  // When the user clicks on <span> (x), close the modal
  modalClose.onclick = function () {
    modal.style.display = 'none'
    resetBookingForm()
  }

  // When the user clicks anywhere outside of the modal, close it
  window.onclick = function (event) {
    if (event.target === modal) {
      modal.style.display = 'none'
      resetBookingForm()
    }
  }

  // check if booking slot element exists
  if ($('#booking_slot').length) {
    // set locale from lang attr
    const lang = $('#booking_slot').attr('data-lang')
    $.datetimepicker.setLocale(lang)

    // disable dates
    const disabledDates = $('input[name="booking_date"]').attr('data-disabled-dates')

    // datepicker
    $('input[name="booking_date"]').datetimepicker({
      timepicker: false,
      minDate: '+1970/01/02',
      closeOnDateSelect: false,
      format: 'd-m-Y',
      formatDate: 'd-m-Y',
      dayOfWeekStart: 1,
      disabledDates: (disabledDates.length) ? disabledDates.split(',') : [],
      onGenerate: function (ct) {
        // set closed days
        let closedDays = $('input[name="booking_date"]').attr('data-closed-days')
        if (closedDays.length) {
          closedDays = closedDays.split(',')
          for (const x in closedDays) {
            $(this).find('.xdsoft_day_of_week' + closedDays[x].trim()).addClass('xdsoft_disabled')
          }
        }
      },
      onChangeDateTime: function (dp, $input) {
        if ($input.val() !== '') {
          $.ajax(bookingVars.url, {
            method: 'post',
            data: {
              _nonce: bookingVars.nonce,
              action: 'get_booking_time',
              store_id: $('input[name="store_id"]').val(),
              chosen_day: $input.val(),
              lang: bookingVars.lang
            }
          })
            .success(function (response) {
              const allowedTimes = response.data.intervals
              $('input[name="booking_time"]').datetimepicker('setOptions', {
                allowTimes: allowedTimes,
                defaultTime: allowedTimes[0]
              })
            })
            .error(function () {
              console.log('error')
            })
        }
      }
    })

    // timepicker
    $('input[name="booking_time"]').datetimepicker({
      datepicker: false,
      format: 'H:i',
      formatTime: 'H:i',
      step: '60',
      validateOnBlur: false,
      minTime: '9:00',
      maxTime: '18:00'
    })

    // set default time on time datetimepicker for tomorrow date (if possible)
    getDefaultDate()
  }

  function getTomorrow (isForTimePicker = false) {
    const tomorrow = new Date()
    tomorrow.setDate(tomorrow.getDate() + 1)

    if (isForTimePicker) {
      return [
        padTo2Digits(tomorrow.getDate()),
        padTo2Digits(tomorrow.getMonth() + 1),
        tomorrow.getFullYear()
      ].join('-')
    } else {
      return [
        tomorrow.getFullYear(),
        padTo2Digits(tomorrow.getMonth() + 1),
        padTo2Digits(tomorrow.getDate())
      ].join('/')
    }
  }

  function padTo2Digits (number) {
    return number.toString().padStart(2, '0')
  }

  function getDefaultDate (ct) {
    const tomorrow = getTomorrow(true)
    $.ajax(bookingVars.url, {
      method: 'post',
      data: {
        _nonce: bookingVars.nonce,
        action: 'get_booking_time',
        store_id: $('input[name="store_id"]').val(),
        chosen_day: tomorrow,
        lang: bookingVars.lang
      }
    })
      .success(function (response) {
        const allowedTimes = response.data.intervals
        $('input[name="booking_time"]').datetimepicker('setOptions', {
          allowTimes: allowedTimes,
          defaultTime: allowedTimes[0]
        })
      })
      .error(function () {
        console.log('error')
      })
  }

  function resetBookingForm () {
    $('#booking-form-submit').show()
    $('#bookAppointmentModal .modal-body').show()
    $('#bookAppointmentModal .modal-loading-body').hide()
    $('#bookAppointmentModal .modal-loading-body.success').hide()
    // reset form
    $('#booking-form').each(function () {
      this.reset()
    })
  }

  if ($('#booking-form').length) {
    $('#booking-form').submit(function (e) {
      e.preventDefault()
      // disable button
      $('#booking-form-submit').hide()
      $('#bookAppointmentModal .modal-loading-body').show()
      $('#bookAppointmentModal .modal-loading-body.success').hide()
      $('#bookAppointmentModal .modal-body').hide()

      // hide error/success messages
      $('#booking-form-success').hide()
      $('#booking-form-error').hide()
      $('#booking-form-error-message').text()

      grecaptcha.ready(function () {
        grecaptcha.execute('6Lc57RwkAAAAACz0IC9Kxx-Nwabd18MTOyAZQpdN', { action: 'submit' }).then(function (token) {
          const data = {
            _nonce: bookingVars.nonce,
            action: 'rimadesio_store_booking',
            first_name: $('#booking-form input[name="first_name"]').val(),
            last_name: $('#booking-form input[name="last_name"]').val(),
            store_id: $('#booking-form input[name="store_id"]').val(),
            email: $('#booking-form input[name="email"]').val(),
            phone: $('#booking-form input[name="phone"]').val(),
            booking_date: $('#booking-form input[name="booking_date"]').val(),
            booking_time: $('#booking-form input[name="booking_time"]').val(),
            lang: $('#booking-form input[name="lang"]').val(),
            privacy: $('#booking-form input[name="privacy"]').val(),
            marketing : $('#booking-form input[name="privacy_marketing"]:checked').val(),
            profiling : $('#booking-form input[name="profiling"]:checked').val(),
            current_url : $('#booking-form input[name="current_url"]').val(),
            storeID : $('#booking-form input[name="store_ID"]').val(),
            token: token
          }

          // go go ajax!
          $.ajax(bookingVars.url, {
            method: 'post',
            data: data
          })
            .success(function (response) {
              $('#bookAppointmentModal .modal-loading-body').hide()

              if (response.success === true) {
                $('#bookAppointmentModal .modal-loading-body.success').show()
                // send booking GAevent to dataLayer
                window.dataLayer.push({
                  event: 'GAevent',
                  eventCategory: 'Appointment',
                  eventAction: 'Book',
                  eventLabel: 'Book'
                })
              } else {
                $('#booking-form-submit').show()
                $('#bookAppointmentModal .modal-body').show()
                $('#booking-form-error').show()
                $('#booking-form-error-message').text(response.data.error_message)
                $('#booking-form-success').delay(5000).fadeOut('slow')
              }
            })
            .error(function () {
              console.log('AJAX Booking error')
              $('#booking-form-submit').show()
              $('#bookAppointmentModal .modal-loading-body').hide()
              $('#bookAppointmentModal .modal-loading-body.success').hide()
              $('#bookAppointmentModal .modal-body').show()
              // show error
              $('#booking-form-error').show()
              $('#booking-form-error').delay(3000).fadeOut('slow')
            })
        })
      })
    })
  }
})
